import flatten from '@utils/flatten';
import { sortObjectArray } from '@utils/sort-by-object-property';
import { getScoresForChapters, getScoresForChapterAssets } from '@utils/module-completion-calculator';
import { ASSET_TYPES } from '../constants';

export default {
  data() {
    return {
      chaptersReady: false,
    };
  },

  computed: {
    sortedChapters() {
      if (this.chapters) {
        return sortObjectArray(this.chapters, 'number');
      }
      return [];
    },

    assets() {
      if (this.sortedChapters) {
        return flatten(this.sortedChapters.map(ch => sortObjectArray(ch.assets, 'number') || []));
      }
      return [];
    },

    paks() {
      return this.assetsOfType('pak');
    },

    lus() {
      return this.assetsOfType('learning_unit');
    },

    videos() {
      return this.assetsOfType('video');
    },

    slides() {
      return this.assetsOfType('slide_deck');
    },

    quizzes() {
      return this.assetsOfType('quiz');
    },

    events() {
      return this.assetsOfType('calendar_event');
    },

    meetings() {
      return this.assetsOfType('meeting');
    },

    pages() {
      return this.assetsOfType('markdown_page');
    },

    questionnaires() {
      return this.assetsOfType('questionnaire');
    },

    chapterAssetCompletionScores() {
      return getScoresForChapterAssets(this.chapters);
    },

    chapterCompletionScores() {
      return getScoresForChapters(this.chapters);
    },
  },

  methods: {
    assetsOfType(assetType) {
      if (!(assetType in ASSET_TYPES)) {
        return undefined;
      }
      return this.assets?.filter(a => a.asset_type === assetType) || [];
    },
  },
};
